import { Loader2 } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { LoginPage } from '../pages/LoginPage';

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center bg-surface-canvas">
        <Loader2 className="h-6 w-6 animate-spin text-byte-purple" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  return <>{children}</>;
}
